import Text from '@cartwhl/ui/base/TextNew';

import { pageFrame } from '../page-frame';
import { publicPageGutters } from '../public-page-gutters';
import ComicPerformanceChart from './ComicPerformanceChart/index';
import ModelIntro from './ModelIntro';
import {
  ActionCard,
  CapabilityCard,
  ModelCard,
  SectionLabel,
} from './components';
import { commitContent } from './content';

export default function CommitPage() {
  return (
    <div className={pageFrame}>
      <ModelIntro intro={commitContent.intro} model="comic" />
      <section
        className={`border-primary flex flex-col gap-10 border-b py-10 sm:gap-20 sm:py-20 ${publicPageGutters}`}
      >
        <SectionLabel>Models</SectionLabel>
        <div className="grid gap-6 min-[960px]:grid-cols-2 min-[960px]:gap-10 min-[1360px]:grid-cols-3">
          {commitContent.models.map((card) => (
            <ModelCard key={card.id} card={card} />
          ))}
        </div>
      </section>
      <section className={`border-primary border-b py-20 ${publicPageGutters}`}>
        <Text
          as="h2"
          token={{
            base: 'display/32/bold',
            sm: 'display/40/bold',
            lg: 'display/56/bold',
            xl: 'display/64/bold',
            '2xl': 'display/88/bold',
          }}
          leading="editorial"
          className="max-w-[1320px] text-pretty"
        >
          The fastest, most accurate, feature-rich{' '}
          <span className="text-green">video performance capture model.</span>
        </Text>
      </section>
      <section
        className={`border-primary flex flex-col gap-10 border-b py-10 sm:gap-20 sm:py-20 ${publicPageGutters}`}
      >
        <SectionLabel>Capabilities</SectionLabel>
        <div className="grid gap-6 min-[960px]:grid-cols-2 min-[960px]:gap-10 min-[1360px]:grid-cols-3">
          {commitContent.capabilities.map((capability) => (
            <CapabilityCard
              key={capability.id}
              capability={capability}
              mediaClassName="aspect-video"
            />
          ))}
        </div>
      </section>
      <section
        id="comic-performance"
        className={`border-primary flex scroll-mt-24 flex-col gap-10 border-b py-10 sm:gap-20 sm:py-20 ${publicPageGutters}`}
      >
        <SectionLabel>Performance</SectionLabel>
        <ComicPerformanceChart performance={commitContent.performance} />
      </section>
      <section
        className={`border-primary flex flex-col gap-10 border-b py-10 sm:gap-20 sm:py-20 ${publicPageGutters}`}
      >
        <div className="flex max-w-[648px] flex-col gap-10">
          <SectionLabel>{commitContent.action.title}</SectionLabel>
          <Text
            as="p"
            token="24"
            leading="editorial"
            className="text-secondary text-pretty"
          >
            {commitContent.action.description}
          </Text>
        </div>
        <div className="grid gap-6 min-[960px]:grid-cols-2 min-[960px]:gap-10">
          {commitContent.action.cards.map((card) => (
            <ActionCard key={card.id} {...card} />
          ))}
        </div>
      </section>
    </div>
  );
}
